import { get } from "lodash";
import moment from "moment";
import { GENDER, REGEX_EXPS } from "utils/constants";
import { validateNIR } from "utils/helpers/values";
import * as yup from "yup";

const validateSocialSecurityNumber = function (value) {
  if (!value) return true;
  const prefix = `${
    (get(this.parent, "user.gender") === GENDER.MALE && "[17]") ||
    (get(this.parent, "user.gender") === GENDER.FEMALE && "[28]") ||
    "[1278]"
  }${moment(get(this.parent, "user.birthDate")).format("YY")}${moment(
    moment(get(this.parent, "user.birthDate")),
  ).format("MM")}`;
  const regexPattern = new RegExp(`^${prefix}(?:[0-9]{10})$`);
  return new RegExp(regexPattern).test(value);
};

const getAge = (birthdate) => {
  if (!birthdate) return 0;
  const today = new Date();
  const birth = new Date(birthdate);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

const validation = (messages, { hasPartner = false }) => {
  const string = yup
    .string()
    .required(messages.REQUIRED)
    .typeError(messages.NOT_STRING)
    .nullable();

  const nameValidation = yup
    .string()
    .required(messages.REQUIRED)
    .test("is-valid-name", messages.INVALID_NAME, (value) => {
      return !value || REGEX_EXPS.name.test(value);
    });

  const spouseValidationSchema = yup.object().shape({
    identity: yup.object().shape({
      user: yup.object().shape({
        lastname: nameValidation.required(messages.REQUIRED),
        firstname: nameValidation.required(messages.REQUIRED),
        gender: string,
      }),
      socialSecurityNumber: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .test(
          "validateNIR",
          messages.INVALID_SOCIAL_SECURITY_NUMBER,
          function (value, ctx) {
            const result = validateNIR(value, this.parent);
            if (!result.valid)
              return ctx.createError({
                message: messages[result.reason] || messages.INVALID_VALUE,
              });

            return true;
          },
        ),
    }),
  });

  const childrenValidationSchema = yup.object().shape({
    authority: yup
      .string()
      .nullable()
      .test("required-if-minor", messages.REQUIRED, function (value) {
        const birthdate = this.parent?.identity?.user?.birthDate;
        const age = getAge(birthdate);
        return age >= 18 || (!!value && value.length > 0);
      }),
    identity: yup.object().shape({
      user: yup.object().shape({
        lastname: nameValidation.required(messages.REQUIRED),
        firstname: nameValidation.required(messages.REQUIRED),
        gender: string,
        birthDate: yup.date().required(messages.REQUIRED),
      }),
      socialSecurityNumber: yup
        .string()
        .transform((value) => (value ? value.replace(/\s+/g, "") : value))
        .nullable()
        .test(
          "securityNumberFormat",
          messages.INVALID_VALUE,
          validateSocialSecurityNumber,
        ),
    }),
  });

  return yup.object().shape({
    spouse: hasPartner ? spouseValidationSchema : yup.mixed().notRequired(),
    children: yup.array().of(childrenValidationSchema),
  });
};

export default validation;
